import React, { useEffect, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { get, post, put, del, api } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import Form from "./Form";
import ActionButtons from "../../../Components/Common/ActionButtons";
import ViewData from "./ViewData.jsx";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import CapitalGoodsBulkUploadReview from "./CapitalGoodsBulkUploadReview";
import BulkUploadSkippedDialog from "../../../Components/Common/BulkUploadSkippedDialog";
import {
  Alert,
  Snackbar,
} from "@mui/material";
import { useUser } from "../../../context/AuthContext.js";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog.js";
import {
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
  mapTableDataWithFacility,
} from "../../../utils/facilityColumn";

const CapitalGoods = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedValue, setSelectedValue] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState([]);
  const [matchData, setMatchData] = useState([]);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [excelData, setExcelData] = useState(null);
  const [skippedUploadDialog, setSkippedUploadDialog] = useState({
    open: false,
    skippedEntries: [],
    inserted: 0,
    skipped: 0,
  });
  const [filters, setFilters] = useState({
    capitalGoodsName: [],
    capitalGoodsCategory: [],
    supplierName: [],
    country: [],
  });

  const [cardData, setCardData] = useState({
    totalInvestment: {
      totalCapitalInvestment: 0,
    },
    mostExpensiveCategory: {
      totalCapitalInvestment: 0,
      capitalGoodsCategory: "",
    },
    highestSpendGoods: {
      highestSpend: 0,
      capitalGoodsName: "",
    },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const headers = withFacilityViewTableHeader([
    { key: "createdAt", label: "Date", sortable: true },
    { key: "purchaseDate", label: "Purchase Date", sortable: true },
    { key: "capitalGoodsName", label: "Name of Capital Good", sortable: true },
    { key: "quantity", label: "Quantity Purchased", sortable: true },
    { key: "usefulLife", label: "Useful Life(Years)", sortable: true },
  ], showFacilityColumn);

  const inputData = [
    {
      fieldName: "purchaseDate",
      title: "Purchase Date",
    },
    {
      fieldName: "capitalGoodsCategory",
      title: "Capital Goods Category",
    },
    {
      fieldName: "capitalGoodsName",
      title: "Name of the Capital Good",
    },
    {
      fieldName: "supplierName",
      title: "Vendor/Supplier Name",
    },
    {
      fieldName: "quantity",
      title: "Quantity Purchased",
    },
    {
      fieldName: "cost",
      title: "Total Cost (in USD)",
    },
    {
      fieldName: "usefulLife",
      title: "Useful Life (Years)",
    },
    {
      fieldName: "country",
      title: "Country of Manufacture",
    },
    {
      fieldName: "materialComposition",
      title: "Material Composition",
    },
    {
      fieldName: "weightOfCapitalGoods",
      title: "Weight of Capital Good",
    },
    {
      fieldName: "description",
      title: "Remark (optional)",
    },
  ];

  const formatTo4 = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return "-";
    const fixed = n % 1 === 0 ? String(n) : n.toFixed(4).replace(/\.?0+$/, "");
    const [intPart, decPart] = fixed.split(".");
    const formattedInt = Number(intPart).toLocaleString("en-US");
    return decPart ? `${formattedInt}.${decPart}` : formattedInt;
  };



  let bannerData = [
    {
      title: "Total Capital Investment",
      description: formatTo4(cardData?.totalInvestment?.totalCapitalInvestment ?? 0) + " USD",
    },
    {
      title: "Most expensive capital category",
      description: cardData?.mostExpensiveCategory?.capitalGoodsCategory
        ? `${cardData.mostExpensiveCategory.capitalGoodsCategory} - USD`
        : "N/A",
    },
    {
      title: "Highest spend Good",
      description: cardData?.highestSpendGoods?.capitalGoodsName
        ? `${cardData.highestSpendGoods.capitalGoodsName} (${formatTo4(
          cardData?.highestSpendGoods?.highestSpend ?? 0
        )} USD)`
        : "N/A",
    },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "date", value: [] },
    { title: "Purchase Date", type: "date", key: "purchaseDate", value: [] },
    {
      title: "Capital Goods Name",
      type: "option",
      key: "capitalGoodsName",
      value: filters?.capitalGoodsName,
    },
    {
      title: "Capital Goods Category",
      type: "option",
      key: "capitalGoodsCategory",
      value: filters?.capitalGoodsCategory,
    },
    {
      title: "Supplier Name",
      type: "option",
      key: "supplierName",
      value: filters?.supplierName,
    },
    {
      title: "Country of Manufacture",
      type: "option",
      key: "country",
      value: filters?.country,
    },
  ];

  const uploadErrorClose = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(false);
    setMatchData([]);
    setFormDataBulkUpload([]);
    fetchData();
    fetchCardData();
  };

  const fetchExcelData = async () => {
    // Excel template with headers matching backend API expectations
    // Backend expects these exact column names for bulk upload validation
    const defaultCategories = [
      "Machinery and industrial equipment",
      "Manufacturing equipment",
      "IT equipment",
      "Buildings and infrastructure",
      "Vehicles",
      "Laboratory equipment",
      "Electrical equipment",
      "Office furniture",
      "Construction materials",
    ];

    const template = defaultCategories.map((category, idx) => ({
      "S No.": idx + 1,
      "Purchase Date (DD/MM/YYYY)": "",
      "Capital Goods Name": "",
      "Capital Goods Category": category,
      "Supplier Name": "",
      "Quantity": "",
      "Unit (Tonnes or Units)": "",
      "Cost(USD)": "",
      // "Currency": "",
      "Useful Life (Years)": "",
      "Country of Manufacture": "",
      "Material Composition": "",
      "Weight of Capital Good (kg)": "",
      "Description": "",
    }));
    setExcelData(template);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchData = async () => {
    let filter = { ...filterObj };
    if (filter.date) {
      filter.startDate = filter?.date?.start;
      filter.endDate = filter?.date?.end ? filter?.date?.end : new Date();
      delete filter.date;
    }
    if (filter.purchaseDate) {
      filter.purchaseStartDate = filter?.purchaseDate?.start;
      filter.purchaseEndDate = filter?.purchaseDate?.end
        ? filter?.purchaseDate?.end
        : new Date();
      delete filter.purchaseDate;
    }

    // Normalize filter values so backend receives usable query params.
    Object.keys(filter).forEach((key) => {
      const value = filter[key];
      if (Array.isArray(value)) {
        filter[key] = value.filter(Boolean).join(",");
      } else if (value === undefined || value === null || value === "") {
        delete filter[key];
      }
    });
    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: 10,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();

    try {
      const res = await get(
        `/scope3/capitalGoodsEmissions/get?${queryParams}`
      );

      const arr = (res?.data?.data || []).map((item) => {
        const quantityValue =
          typeof item?.quantity === "object"
            ? item?.quantity?.value
            : item?.quantity;

        const quantityUnit =
          item?.quantityUnit ||
          (typeof item?.quantity === "object"
            ? item?.quantity?.unit
            : "") ||
          "";

        return {
          ...item,
          capitalGoodsName: item?.capitalGoodsName || "-",
          quantity: quantityValue || "-",
          quantityUnit,
          action: "View",
          id: item?._id,
        };
      });

      setTableData(arr);
      setTotalPages(res?.data?.totalPages);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage]);

  const fetchFilters = async () => {
    try {
      const res = await get(`/scope3/capitalGoodsEmissions/filter`);
      const apiFilterData = res?.data?.data || {};
      setFilters({
        capitalGoodsName:
          apiFilterData?.capitalGoodsName || apiFilterData?.goodsName || [],
        capitalGoodsCategory:
          apiFilterData?.capitalGoodsCategory || apiFilterData?.category || [],
        supplierName:
          apiFilterData?.supplierName || apiFilterData?.supplier || [],
        country: apiFilterData?.country || [],
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    if (isFilterModalOpen) {
      fetchFilters();
    }
  }, [isFilterModalOpen]);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/capitalGoodsEmissions/cardData`);
      const apiData = res?.data?.data || {};
      setCardData({
        totalInvestment: apiData?.totalInvestment || {
          totalCapitalInvestment: 0,
        },
        mostExpensiveCategory: apiData?.mostExpensiveCategory || {
          totalCapitalInvestment: 0,
          capitalGoodsCategory: "",
        },
        highestSpendGoods: apiData?.highestSpendGoods || {
          highestSpend: 0,
          capitalGoodsName: "",
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setEditModal(false);
      setEditData({});
      setIsModalOpen(true);
    } else if (type === "edit") {
      setIsModalOpen(true);
      if (dataForEdit?.createdAt) {
        dataForEdit.createdAt = dataForEdit.createdAt.split("T")[0];
      }
      if (dataForEdit?.purchaseDate) {
        dataForEdit.purchaseDate = dataForEdit.purchaseDate.split("T")[0];
      }
      setEditData(dataForEdit);
      setEditModal(true);
      setViewModal(false);
    }
  };

  const handleEdit = (data) => {
    if (data?.createdAt) {
      data.createdAt = data.createdAt.split("T")[0];
    }
    if (data?.purchaseDate) {
      data.purchaseDate = data.purchaseDate.split("T")[0];
    }
    setIsModalOpen(true);
    setEditData(data);
    setEditModal(true);
    setViewModal(false);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    } else if (type === "edit") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, type) => {
    try {
      const payload = {
        ...data,
        quantity:
          data?.quantity === "" || data?.quantity === undefined
            ? ""
            : Number(data.quantity),
        quantityUnit: data?.quantityUnit || "",
      };
      if (type) {
        let res = await put(
          `/scope3/capitalGoodsEmissions/update?Id=${editData._id}`,
          payload
        );
        if (res) {
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          setIsModalOpen(false);
          setEditModal(false);
          setEditData({});
          fetchCardData();
        }
      } else {
        let res = await post(`/scope3/capitalGoodsEmissions/add`, payload);
        if (res) {
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          setIsModalOpen(false);
          setEditModal(false);
          setEditData({});
          fetchCardData();
        }
      }

      fetchData();
      fetchCardData()
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message || "Something went wrong",
        severity: "error",
      });
      console.log("Error in handleSubmit:", error.response?.data?.message);
    }
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value);
  };

  const handleDeleteOpen = (itemId) => {
    setDeletedItemId(itemId);
    setDeleteDialog(true);
  };



  return (
    <>
      <Cards
        data={bannerData}
        title={"Capital Goods"}
        onFilterChange={handleSelectChange}
      />
      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />

      <ViewTable
        title={"Capital Goods"}
        headers={headers}
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        onSort={handleSort}
        sortConfig={sortConfig}
        page={currentPage}
        count={pageSize}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        totalPages={totalPages}
        actionColumnWidthPx={96}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row)}
      />
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={snackOpen.autoHideDuration ?? 3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Form
        isOpen={isModalOpen}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={
          editModal
            ? "Edit Capital Goods Emission Data"
            : "Add Capital Goods Emission Data"
        }
        id={editModal ? editData?._id : "add"}
        initialData={editData}
        isEditing={editModal}
      />

      <ViewData
        id={editData ? editData._id : ""}
        element={editData}
        title={"Emissions"}
        viewData={viewModal}
        setViewData={setViewModal}
        setData={setEditData}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: deletedItemId?._id,
            url: `${api}/scope3/capitalGoodsEmissions/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"capitalGoods"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/capitalGoodsEmissions/bulkupload"}
          setMatchData={setMatchData}
          setFormDataBulkUpload={setFormDataBulkUpload}
          matchedKey="capitalGoodsStatusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
        />
      )}

      {bulkUploadTable && (
        <CapitalGoodsBulkUploadReview
          bulkUploadTable={bulkUploadTable}
          matchData={matchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setsnackOpen={setsnackOpen}
          bulkUploadUrl="/scope3/capitalGoodsEmissions/jsonupload"
          onClose={() => setBulkUploadTable(false)}
          onConfirm={(data) => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
            fetchCardData();

            const skippedEntries = data?.skippedEntries;
            const hasSkipped =
              Array.isArray(skippedEntries) && skippedEntries.length > 0;
            const inserted = Number(data?.inserted ?? 0);
            const skipped = Number(data?.skipped ?? 0);


            if (hasSkipped) {
              setSkippedUploadDialog({
                open: true,
                skippedEntries,
                inserted,
                skipped,
              });
            }
          }}
        />
      )}

      <BulkUploadSkippedDialog
        open={skippedUploadDialog.open}
        skippedEntries={skippedUploadDialog.skippedEntries}
        inserted={skippedUploadDialog.inserted}
        skipped={skippedUploadDialog.skipped}
        downloadFileName="capitalGoods_skipped"
        onClose={() =>
          setSkippedUploadDialog({
            open: false,
            skippedEntries: [],
            inserted: 0,
            skipped: 0,
          })
        }
        // onDownload={(rows) => setExcelData(rows)}
      />
    </>
  );
};

export default CapitalGoods;
